export const STYLES = {
  INDEX: {
    LAYOUT: 'absolute inset-0 z-[50] bg-bw00 h-screen w-screen flex flex-col fadeIn overflow-hidden',
  },
  CREATE_BILL_BODY: {
    WRAPPER: 'bg-bw01 flex items-center justify-center grow shadow-light py-[24px] px-[66px] gap-[1px] ',
    FORM_WRAPPER: 'relative basis-1/2 h-full bg-bw00 rounded-[8px] shadow-light',
    FORM_ITEM_WRAPPER:
      'w-full hover:shadow-light mx-auto px-[20px] py-[20px] rounded-[8px] border border-bw03 mb-[20px]',
    FORM_ITEM_WRAPPER_UN_STYLED: 'w-full mx-auto mb-[20px]',
    FLOATING_SCROLLABLE_DIV: 'absolute inset-0 px-[24px] pt-[24px] pb-[100px] rounded-[8px] overflow-auto no-scrollbar',
    BILL_AMOUNT: {
      WRAPPER: 'flex flex-col gap-[12px]',
      TITLE: 'font-metricRMedium text-bw08 text-[18px]',
      CURRENCY_INPUT:
        'w-full h-[50px] bg-bw00 box-border border border-bw06 focus:border-action03 hover:bg-bw01 outline-none px-[16px] rounded-md font-metricR text-[16px] text-bw08 text-left',
    },
    BILL_NUMBER: {
      WRAPPER: 'flex flex-col gap-[12px]',
      HEADER_WRAPPER: 'flex items-center gap-[4px]',
      TITLE: 'font-metricRMedium text-bw08 text-[18px]',
      TITLE_POST: 'font-metricRMedium text-bw06 text-[16px]',
      INPUT:
        'w-full h-[50px] bg-bw00 box-border border border-bw06 focus:border-action03 hover:bg-bw01 outline-none px-[16px] rounded-md font-metricR text-[16px] text-bw08 text-left',
    },
    DUE_DATE: {
      WRAPPER: 'flex flex-col gap-[12px] relative',
      DATE_PICKER:
        'relative w-full min-h-[44px] bg-bw00 box-border border border-bw06 focus:border-action03 hover:bg-bw00 outline-none px-[16px] rounded-md font-metricR text-[16px] text-bw08 text-left',
      CALENDAR: 'shadow-light !absolute !translate-y-[-125%]',
      ICON: 'absolute right-[0px] -translate-x-[12px] top-1/2 -translate-y-1/2 z-50 h-[24px] w-[24px] text-bw06 cursor-pointer',
    },
    PAYMENT_FREQUENCY: {
      TITLE: 'font-metricRMedium text-bw08 text-[16px]',
    },
    PAYMENT_REMINDER: {
      WRAPPER: 'flex flex-col',
      HEADER_WRAPPER: 'flex items-center gap-[8px]',
      TITLE: 'font-metricRMedium text-bw08 text-[18px]',
      SUB_TITLE: 'font-metricR text-bw08 text-16px',
      TITLE_DISABLED: 'font-metricRMedium text-bw06 text-[18px]',
      SUB_TITLE_DISABLED: 'font-metricR text-bw06 text-16px',
    },
    DOC_PREVIEW: {
      WRAPPER:
        'pt-[24px] pb-[90px] px-[24px] flex flex-col items-center justify-start basis-1/2 h-full bg-bw00 rounded-[8px] shadow-light',
      DOC_WRAPPER:
        'relative w-full h-full bg-bw01 shadow-light_document border border-action01 rounded-[8px] py-[24px] px-[72px]',
      FLOATING_ASSET_WRAPPER: 'absolute inset-0 flex items-center justify-center py-[14px] px-[50px] max-h-[660px]',
      ASSET: 'object-contain w-full h-full max-w-[600px]',
      ACTIONS_CONTAINER:
        'absolute bottom-[15px] left-[50%] translate-x-[-50%] bg-bw00 rounded-[8px] shadow-bottomShadow border border-bw03 py-[8px] px-[15px] flex items-center',
      TT_CHILDREN_WRAPPER:
        'fadeIn before:w-[10px] before:h-[10px] before:bg-bw08 before:border-bw08 before:border-b before:border-r before:absolute before:left-[50%] before:translate-x-[-50%] before:rotate-[45deg] before:translate-y-[55%] ' +
        'before:bottom-0 absolute z-[9999] top-0 left-[50%] translate-x-[-50%] translate-y-[calc(-100%-10px)] bg-bw08 border border-bw08 px-[12px] py-[8px] rounded-[6px] shadow-light w-[120px] flex items-center justify-center',
      TT_HEADER: 'font-metricR text-bw00 text-[14px]',
      TT_TRIGGER: 'py-[8px] px-[8px] flex items-center justify-center rounded-[8px] hover:bg-bw02',
      TT_TRIGGER_ICON: 'w-[24px] stroke-[#E74343] hover:cursor-pointer',
    },
  },
  FOOTER: {
    WRAPPER: 'absolute bottom-0 bg-bw00 left-0 border-t border-bw03 w-full flex items-center justify-center py-[16px]',
    CTA: 'w-[470px]',
    CTA_DISABLED: 'w-[470px] py-[18px] rounded-[4px] bg-bw05 font-metricR text-[16px] text-bw00',
  },
  TITLE: 'font-metricR text-bw08 text-[18px] mb-[10px] mt-[8px]',
  WRAPPER: 'min-w-[500px] mx-auto my-0 h-full flex justify-center flex-col',
  BILL_INFO_WRAPPER: 'border-[0.8px] rounded-[8px] border-bw03 p-4',
  FLEX_BETWEEN: 'flex justify-between items-center',
  BORDER_BOTTOM: ' border-b-[0.8px] border-bw03 pb-[16px]',
  BILL_ITEM: 'font-metricR text-bw07 text-[16px]',
  BILL_VALUE: 'font-metricR text-bw08 text-[16px]',
  PRICE: 'font-metricR text-action03 text-[22px]',
  BUTTON_PROCEED:
    'bg-action03 hover:bg-action04 active:bg-action04 text-sm font-metricRMedium text-bw00 px-[24px] py-[17px] w-[279px] rounded-[4px] mb-3 fadeIn',
  BUTTON_MAKE_BILL:
    'text-sm font-metricRMedium text-action03 px-[24px] py-[17px] w-[279px] border-[1px] rounded-[4px] fadeIn',
  DONE: 'text-sm font-metricRMedium text-bw08 mt-[16px] w-[279px]',
  ACTIONS_WRAPPER: 'flex flex-col items-center mt-[70px] mb-[30px]',
  FILE_PREVIEW: 'rounded-[8px] px-[16px] py-[12px] bg-bw01 border-[1px] border-bw04 mt-[16px] flex items-center',
};
export const TEXTS = {
  BILL_DETAILS: 'Bill details',
  AMOUNT: 'Amount',
  DUE_DATE: 'Due date',
  BILL_NUMBER: 'Bill no.',
};

export const BUTTONS_TITLES = {
  PROCEED_TO_PAYMENT: 'Proceed to Payment',
  MAKE_BILL: 'Add Another Bill',
  DONE: 'Done',
};
export const INITIAL_BILL_DATA_MODEL = {
  billId: '',
  amount: 0,
  billNumber: '',
  dueDate: new Date(),
  supplierName: '',
  supplierId: '',
  billImageUrl: '',
  documentId: '',
  assetType: '',
  assetName: '',
  paymentReminderData: null,
  recurringPaymentData: null,
};

export const DEFAULT_BILL_NUMBER = '0000';

export const BREADCRUMB_DATA = (isDuplicateMode?: boolean) => [
  { name: 'CREATE_BILL.BREADCRUMB.BILL_PAY' },
  { name: isDuplicateMode ? 'CREATE_BILL.BREADCRUMB.DUPLICATE_BILL' : 'CREATE_BILL.BREADCRUMB.ADD_NEW_BILL' },
];
